import { DEFAULT_DISPLAY_THEME } from 'config/theme.config';
import { DEFAULT_CHART_OPTIONS } from 'utils/charts/chartStyle.utils';
import { DEFAULT_MAP_OPTIONS } from 'utils/maps/mapTile.utils';
import { ACCESSIBILITY_COLOR_MODES } from 'config/accessibilityTheme.config';

export const DISPLAY_THEME_STORAGE_KEY = 'fusion.displayTheme.v1';
export const MAP_OPTIONS_STORAGE_KEY = 'fusion.mapOptions.v1';
export const CHART_OPTIONS_STORAGE_KEY = 'fusion.chartOptions.v1';
export const ACCESSIBILITY_OPTIONS_STORAGE_KEY = 'fusion.accessibilityOptions.v1';
export const NAVIGATION_STYLE_STORAGE_KEY = 'fusion.navigationStyle.v1';

/**
 * The navigation layout (Mike, 2026-09-26): Merlin Slate — Jacob's redesigned navigation, named
 * for the slate blue-gray falcon its gray-to-blue gradient recalls — or the Classic navigation it
 * replaced. Kept on this device only.
 */
export const NAVIGATION_STYLES = Object.freeze({ MERLIN: 'merlin', CLASSIC: 'classic' });
export const DEFAULT_NAVIGATION_STYLE = NAVIGATION_STYLES.MERLIN;

export const DEFAULT_ACCESSIBILITY_OPTIONS = {
  colorMode: ACCESSIBILITY_COLOR_MODES.DEFAULT,
};

export const DEFAULT_DISPLAY_OPTIONS = {
  displayTheme: DEFAULT_DISPLAY_THEME,
  mapOptions: DEFAULT_MAP_OPTIONS,
  chartOptions: DEFAULT_CHART_OPTIONS,
  accessibilityOptions: DEFAULT_ACCESSIBILITY_OPTIONS,
};

export const ACCESSIBILITY_DISPLAY_STYLE_BY_COLOR_MODE = {
  [ACCESSIBILITY_COLOR_MODES.DEFAULT]: 'default',
  [ACCESSIBILITY_COLOR_MODES.MONOCHROME]: 'monochrome',
  [ACCESSIBILITY_COLOR_MODES.ENHANCED_CONTRAST]: 'enhancedContrast',
  [ACCESSIBILITY_COLOR_MODES.HIGH_CONTRAST]: 'highContrast',
};
